export const styles = theme => ({
  panel: {
    position: 'relative',
    padding: '28px 24px 24px',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    textAlign: 'center'
  },
  close: {
    position: 'absolute',
    top: 4,
    right: 4,
    color: '#94A3B8'
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 20,
    fontWeight: 600,
    color: '#1E2338'
  },
  titleIcon: {
    fontSize: 24,
    color: '#25D366'
  },
  doneIcon: {
    fontSize: 44,
    color: '#25D366',
    marginBottom: 4
  },
  blurb: {
    margin: '10px auto 20px',
    maxWidth: 320,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 15,
    lineHeight: 1.5,
    color: '#475569'
  },
  field: {
    width: '100%',
    marginBottom: 14
  },
  error: {
    marginBottom: 12,
    fontSize: 14,
    color: '#DC2626'
  },
  submit: {
    width: '100%',
    height: 48,
    borderRadius: 999,
    background: '#25D366',
    color: '#ffffff',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: '0 4px 14px rgba(37, 211, 102, 0.3)',
    '&:hover': {
      background: '#1FBF5B'
    },
    '&.Mui-disabled': {
      background: '#CBD5E1',
      color: '#ffffff'
    }
  },
  // "Chat here" (the website chat widget) and "Start chat": the primary
  // choice on a desktop, in ink so it does not read as WhatsApp.
  chatHere: {
    width: '100%',
    height: 48,
    marginBottom: 12,
    borderRadius: 999,
    background: '#1C202F',
    color: '#ffffff',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      background: '#0F121C'
    },
    '&.Mui-disabled': {
      background: '#CBD5E1',
      color: '#ffffff'
    }
  },
  // A phone's two equal choices: "Chat here" (ink) and "WhatsApp" (green),
  // the same size, one above the other.
  choices: {
    display: 'flex',
    flexDirection: 'column'
  },
  whatsappChoice: {
    width: '100%',
    height: 48,
    borderRadius: 999,
    background: 'var(--whatsapp)',
    color: 'var(--on-accent)',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      background: 'var(--whatsapp)',
      boxShadow: 'none'
    }
  },
  // "Chat here instead", under the WhatsApp step on a desktop.
  instead: {
    marginTop: 20,
    paddingTop: 16,
    borderTop: '1px solid var(--line)',
    '& > *': { marginBottom: 0 }
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    margin: '22px 0 16px',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 13,
    color: '#94A3B8',
    '&::before, &::after': {
      content: '""',
      flex: 1,
      borderTop: '1px solid #E2E8F0'
    }
  },
  submitQuiet: {
    width: '100%',
    height: 48,
    borderRadius: 999,
    borderColor: '#25D366',
    color: '#15803D',
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'none',
    '&:hover': {
      borderColor: '#1FBF5B',
      background: 'rgba(37, 211, 102, 0.06)'
    },
    '&.Mui-disabled': {
      borderColor: '#E2E8F0',
      color: '#94A3B8'
    }
  },
  note: {
    marginTop: 14,
    fontFamily: "Poppins, 'Helvetica Neue', sans-serif",
    fontSize: 12,
    lineHeight: 1.5,
    color: '#94A3B8'
  }
})
